import { componentQrl, inlinedQrl, _jsxS, _jsxC, Slot } from "@builder.io/qwik";
const SectionComponent = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  return /* @__PURE__ */ _jsxS("section", {
    ...props.attributes,
    children: /* @__PURE__ */ _jsxC(Slot, null, 3, "2Y_0"),
    style: {
      width: "100%",
      alignSelf: "stretch",
      flexGrow: 1,
      boxSizing: "border-box",
      maxWidth: props.maxWidth || 1200,
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      marginLeft: "auto",
      marginRight: "auto"
    }
  }, null, 0, "2Y_1");
}, "SectionComponent_component_ZWF9iD5WeLg"));
export {
  SectionComponent,
  SectionComponent as default
};
